export default __webpack_public_path__ + "static/media/types-of-hops-infographic.a1694d2f.png";